import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Grid } from "simplydo/react/ui";

import util from "utils/utils";

import type { FeedCardSharedProps, FeedDiscoverChallengeItem } from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { challenge: FeedDiscoverChallengeItem };

const CardLeft = ({ challenge }: CardLeftProps) => (
  <Grid.Column width={12} verticalAlign="middle">
    <div className="cover-and-text">
      <Link
        to={util.challengeLink(challenge)}
        className="image-link"
        style={{
          width: 60,
          height: 50,
          borderRadius: 10,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundImage: `url(${util.mixinCssUrlFallback(util.challengeImage(challenge), util.challengeImage())})`,
        }}
      />
      <span className="content-name">
        <Link to={util.challengeLink(challenge)}>{challenge.name}</Link>
      </span>
    </div>
  </Grid.Column>
);

type DiscoverChallengeCardProps = FeedCardSharedProps &
  WithTranslation & {
    challenge: FeedDiscoverChallengeItem;
    isMobile?: boolean;
  };

class DiscoverChallengeCard extends Component<DiscoverChallengeCardProps> {
  render() {
    const { challenge, t, hideAction, feedType } = this.props;
    return (
      <FeedCard
        feedType={feedType}
        user={
          challenge.postedByType === "anonymous" ? null : challenge.postedBy
        }
        action={
          challenge.publishedAt
            ? "activityFeed.challenges.actionPublished"
            : "activityFeed.challenges.actionCreated"
        }
        date={challenge.publishedAt || challenge.createdAt}
        toLink={`/challenges/${challenge._id}`}
        type={t("generic.challenge")}
        cardContent={<CardLeft challenge={challenge} />}
        hideAction={hideAction}
      />
    );
  }
}

export default withTranslation()(DiscoverChallengeCard);
